/* eslint-disable */
// import {AuthService} from '../api.service';
// import NProgress from 'nprogress';
// import store from '@/store';
import store from '../state';

var state = {
  pendingRequests: 0,
  originalRequest: {
    _retry: false
  }
};

const onSuccess = (response: any) => {

  state.pendingRequests--;
  if (state.pendingRequests === 0) {
    // NProgress.done();
  }

  // NProgress.done();
  return response.data;
};

const onError = (error: any) => {

  state.pendingRequests--;
  if (state.pendingRequests === 0) {
    // NProgress.done();
  }

  let errorMessage = error.response && error.response.data && error.response.data.message
    ? error.response.data.message
    : null;

  let errorCode = error.response && error.response.data && error.response.data.code
    ? error.response.data.code
    : null;

  if (!error.response) {
    return;
  }


  switch (error.response.status) {
    case 500:
      // Quick hack
      if (errorMessage === 'The token has been blacklisted') {
        // window.reload();
      }
      return Promise.reject(error.response);
      break;
  }
  // NProgress.done();
  return Promise.reject(error.response)
};

const beforeRequestSuccess = (config: any) => {
  state.pendingRequests++;
  // NProgress.start();

  const {
    accessToken,
  } = store.getState();

  if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};

const beforeRequestError = (error: any) => {
  // NProgress.done();
  return Promise.reject(error);
};

export {onSuccess, onError, beforeRequestSuccess, beforeRequestError}
